import { DialogActions, DialogBody, Docked } from '@/ui/dialogs/Dialog';
import i18n from '@i18n';
import React, { FC } from 'react';
import { Button } from 'nike-ui/src/components/button/Button';
import WarningIcon from '@/icons/WarningIcon';
import PopupNg from '@/ui/PopupNg';

interface WarningInfoDialogProps {
    className?: string;
    isIcon?: boolean;
    titleText: string;
    bodyText?: string;
    cancelText?: string;
    confirmText?: string;
}

const WarningInfoDialog: FC<WarningInfoDialogProps> = ({ className, isIcon, titleText, bodyText, cancelText }) => {
    const onClose = () => {
        setTimeout(() => {
            PopupNg.dispatcher.close();
        }, 200);
    };
    /**/
    return (
        <Docked className="auto-cashin-dialog">
            {isIcon ? (
                <div className={'warningDialogIcon'}>
                    <WarningIcon width={100} height={100} fill={'#BFBFBF'} />
                </div>
            ) : null}
            <DialogBody className={className}>
                {titleText ? <h1 className={'warningTextTitle'}>{i18n(titleText)}</h1> : null}
                {bodyText ? <p className={'warningTextParagraph'}>{i18n(bodyText)}</p> : null}
            </DialogBody>
            <DialogActions>
                {cancelText ? (
                    <Button primary className="light warningButton" onClick={onClose}>
                        {i18n(cancelText)}
                    </Button>
                ) : null}
            </DialogActions>
        </Docked>
    );
};

export default WarningInfoDialog;
